/**
 * Адаптер одного элемента ленты Activity.
 * Выбирает рендер пользовательского (`ActivityChatCommentItem`)
 * или системного (`ActivityChatSystemItem`) сообщения.
 */
import { memo } from 'react';
import type { ActivityChatItem } from '@ayocore/activity/common/types/activity-message';
import { ActivityChatCommentItem } from './ActivityChatCommentItem';
import { ActivityChatSystemItem } from './ActivityChatSystemItem';

type ActivityChatMessageItemProps = {
  item: ActivityChatItem;
  showAuthor?: boolean;
  onAction?: (item: ActivityChatItem, actionId: string) => void;
  onInsertUserMention?: (userId: number, label: string) => void;
};

function ActivityChatMessageItemComponent({
  item,
  showAuthor = false,
  onAction,
  onInsertUserMention,
}: ActivityChatMessageItemProps) {
  if (item.kind === 'comment') {
    return (
      <ActivityChatCommentItem
        item={item}
        showAuthor={showAuthor}
        onAction={onAction}
        onInsertUserMention={onInsertUserMention}
      />
    );
  }

  return <ActivityChatSystemItem item={item} />;
}

export const ActivityChatMessageItem = memo(
  ActivityChatMessageItemComponent,
  (prev, next) =>
    prev.item === next.item &&
    prev.showAuthor === next.showAuthor &&
    prev.onAction === next.onAction &&
    prev.onInsertUserMention === next.onInsertUserMention
);
